import { render } from "./DocumentosComponent.vue?vue&type=template&id=436f904f"
import script from "./DocumentosComponent.vue?vue&type=script&lang=js"
export * from "./DocumentosComponent.vue?vue&type=script&lang=js"

import "./DocumentosComponent.vue?vue&type=style&index=0&id=436f904f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__